export const ERROR_MESSAGE = {
  UNAUTHORIZED: 'Unauthorized',
  INVALID_EVENT: 'Evento Inválido',
  RESPONSE_NOT_OK: 'Response not ok',
};

export const NEW_TAB_TARGET = '_blank';
export const NEW_TAB_REL = 'noopener,noreferrer';
